import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { type ScopedPermissions } from '@air/api';
import { permissionsSelector, setPermissionsAction } from '@air/redux-permissions';

import { useAirStore } from '~/utils/ReduxUtils';

export const useCollectionPermissionsCache = () => {
  const store = useAirStore();
  const dispatch = useDispatch();

  const getCollectionPermissions = useCallback(
    (collectionId: string) => permissionsSelector(store.getState(), 'collectionIds', collectionId),
    [store],
  );

  const setCollectionPermissions = useCallback(
    ({ collectionId, permissions }: { collectionId: string; permissions: ScopedPermissions | undefined }) =>
      dispatch(
        setPermissionsAction({
          collectionIds: {
            [collectionId]: permissions,
          },
        }),
      ),
    [dispatch],
  );

  return {
    getCollectionPermissions,
    setCollectionPermissions,
  };
};
